import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FR_EVENT_ROOT_PATH } from '../../router/constants';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';

export function useAutoNavigateToEvent() {
    const unitAssignment = useUnitAssignment();
    const navigate = useNavigate();
    const eventId = unitAssignment?.assignedEvent?.eventId;
    const location = useLocation();

    useEffect(
        function autoNavigateToEvent() {
            if (eventId) {
                const targetPath = `${FR_EVENT_ROOT_PATH}/${eventId}`;

                if (location.pathname !== targetPath) {
                    navigate(targetPath);
                }
            }
        },
        [eventId, navigate, location]
    );
}
